import { render, staticRenderFns } from "./LinkedInLogin.vue?vue&type=template&id=94855dcc&"
import script from "./LinkedInLogin.vue?vue&type=script&lang=js&"
export * from "./LinkedInLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports